import { render, staticRenderFns } from "./StudentFeedback.vue?vue&type=template&id=15dabc52"
import script from "./StudentFeedback.vue?vue&type=script&lang=js"
export * from "./StudentFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports